import { Link } from 'react-router-dom';
import { Button } from '../ui/button.js';

/** Styled 404. Rendered by the router catch-all so unknown paths don't silently redirect. */
export function NotFound({ homeTo = '/' }: { homeTo?: string }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-5 text-center">
      <div>
        <p className="text-6xl font-bold tracking-tight text-primary">404</p>
        <h1 className="mt-3 text-lg font-semibold text-foreground">Page not found</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          That page doesn’t exist or has moved.
        </p>
      </div>
      <Button asChild>
        <Link to={homeTo}>Back to dashboard</Link>
      </Button>
    </div>
  );
}
